<template>
  <!-- ========== Section ctpx-guaranteed-for-good-sec ========== -->
  <section class="ctpx-guaranteed-for-good-sec">
    <div class="container">
      <div class="row flex-row-center mb-4">
        <div class="col-md-4">
          <div class="row">
            <div
              class="col-md-10 offset-md-0 col-xl-10 offset-lg-1 text-center px-0"
            >
              <img
                :src="`${assetsUrl}/guaranteed-for-good-logo.png?v=31469726860796051801655495265`"
                loading="lazy"
                alt="Guaranteed for Good™"
                class="img-responsive"
                width="100%"
                height="auto"
              />
            </div>
            <!-- .col-xl-10 -->
          </div>
          <!-- .row -->
        </div>
        <!-- col-md-4 col-lg-3 -->
        <div class="col-md-8">
          <h1 class="display-1 hidden-mobile">Guaranteed for Good™</h1>
          <h3 class="display-5">Durably Designed. Built To Last.</h3>
          <p class="g4g-copy mb-0">
            We stand behind our products. That's one reason why we've received
            nearly 50,000 5-star reviews. If there's a problem with your
            product, we'll make things right.
          </p>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <div class="container g4g-icons">
      <div class="row flex-nowrap py-3 g4g-icon-row">
        <div class="col-4 text-center px-2">
          <img
            class="img-icon"
            :src="`${assetsUrl}/Icon-Free-Returns-Exchanges.svg`"
            loading="lazy"
            alt="Easy Returns & Exchanges"
          />
          <a
            class="d-block d-md-inline"
            href="https://www.cotopaxi.com/pages/returns"
            target="_blank"
            >Easy Returns and Exchanges</a
          >
        </div>
        <!-- .col-4 -->
        <div class="col-4 text-center px-2">
          <img
            class="img-icon"
            :src="`${assetsUrl}/Icon-Lifetime-Warranty.svg`"
            loading="lazy"
            alt="Lifetime Warranty"
          />
          <a
            class="d-block d-md-inline"
            href="https://www.cotopaxi.com/pages/guaranteed-for-good"
            target="_blank"
            >Lifetime Warranty + Repairs</a
          >
        </div>
        <!-- .col-4 -->
        <div class="col-4 text-center px-2">
          <img
            class="img-icon"
            :src="`${assetsUrl}/Icon-RePurposed.svg`"
            loading="lazy"
            alt="RePurposed"
          />
          <a
            class="d-block d-md-inline"
            href="https://masvida.cotopaxi.com/"
            target="_blank"
            >Trade-In for Gift Cards</a
          >
        </div>
        <!-- .col-4 -->
      </div>
      <!-- .row -->
    </div>
    <!-- .container -->
  </section>
  <!-- .ctpx-ddba-a-sec -->
</template>

<script src="./ctrl-g4g-block.js"></script>
